import styled from 'styled-components'
import Colors from '../constants/Colors'

export const H1 = styled.span`
  font-family: ${({ bold, regular, medium }) =>
    bold ? 'Prompt-Bold' : regular ? 'Prompt-Regular' : medium ? 'Prompt-Medium' : 'Prompt-SemiBold'};
  ${({ colors }) => (colors ? colors : Colors.DARK_GREY)};
  line-height: 56px;
  font-size: 37px;
`

export const H2 = styled.span`
  font-family: ${({ bold, regular, medium }) =>
    bold ? 'Prompt-Bold' : regular ? 'Prompt-Regular' : medium ? 'Prompt-Medium' : 'Prompt-SemiBold'};
  ${({ colors }) => (colors ? colors : Colors.DARK_GREY)};
  line-height: 30px;
  font-size: 21px;
`

export const SubH1 = styled.span`
  font-family: ${({ bold, regular, medium }) =>
    bold ? 'Prompt-Bold' : regular ? 'Prompt-Regular' : medium ? 'Prompt-Medium' : 'Prompt-SemiBold'};
  ${({ colors }) => (colors ? colors : Colors.DARK_GREY)};
  line-height: 24px;
  font-size: 16px;
`

export const SubH2 = styled.span`
  font-family: ${({ bold, regular, medium }) =>
    bold ? 'Prompt-Bold' : regular ? 'Prompt-Regular' : medium ? 'Prompt-Medium' : 'Prompt-SemiBold'};
  ${({ colors }) => (colors ? colors : Colors.DARK_GREY)};
  line-height: 23px;
  font-size: 14px;
`

export const ExtraSmall = styled.span`
  font-family: ${({ bold, regular, medium }) =>
    bold ? 'Prompt-Bold' : regular ? 'Prompt-Regular' : medium ? 'Prompt-Medium' : 'Prompt-SemiBold'};
  ${({ colors }) => (colors ? colors : Colors.DARK_GREY)};
  line-height: 20px;
  font-size: 12px;
`
